import { GET_PROJECT_STUDIO_SESSIONS } from "constants/projects";

export default (state = null, action) => {
  switch (action.type) {
    case `${GET_PROJECT_STUDIO_SESSIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
